import { Avatar, Box, Grid, Badge, Popover, Paper, TextField, CircularProgress, LinearProgress, Backdrop } from "@mui/material";
import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import IconButton from "@mui/material/IconButton";
import { ProfileImage } from './Index';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import PopupState, { bindToggle, bindPopper, bindPopover } from 'material-ui-popup-state';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useDispatch } from "react-redux";
import { axiosFetch } from '../../../utils/AxiosFetch';
import { profile_details } from '../../../redux/actions/user.actions';
import { SnackbarActions } from '../../../redux/actions/snackbar.actions';


const SmallAvatar = styled(Avatar)(({ theme }) => ({
  width: 30,
  height: 30,
  border: `1px solid ${theme.palette.background.paper}`
}));

function ProfileBoard(props) {
  const dispatch = useDispatch();
  var isUserLogged = localStorage.getItem('argus_user') !== null ? JSON.parse(localStorage.getItem('argus_user')) : "";
  const [modalOpen, setModalOpen] = useState(false)
  const [firstName, setFirstName] = useState(props.profile.firstName);
  const [lastName, setLastName] = useState(props.profile.lastName);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  const showProfileImage = () => {
    if(props.profile.originalPhotoName){
      setOpen(!open);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleImagePopup = () => {
    if (modalOpen) {
      setModalOpen(false);
    } else {
      setModalOpen(true);
    }
  }

  const handleNameUpdate = () => {
    if (firstName && lastName) {  
      var format = /[!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]+/;

      if (format.test(firstName) || format.test(lastName)) {
        dispatch(SnackbarActions(true, "warning", "Name should not contain special characters"))
      } else {
        if (firstName !== props.profile.firstName) {
          var req = {
            "TypeId": 1,
            "FieldName": "firstName",
            "Value": firstName,
            "ItemId": props.profile.id,
            "TableName": "EmployeeDetails"
          }
          updateDetails(req)
        }
        else if (lastName !== props.profile.lastName) {
          var req = {
            "TypeId": 1,
            "FieldName": "lastName",
            "Value": lastName,
            "ItemId": props.profile.id,
            "TableName": "EmployeeDetails"
          }
          updateDetails(req)
        }
      }    
      
    }
    else {
      dispatch(SnackbarActions(true, "warning", "Firstname and lastname  should not be blank"))
    }
  }
  const updateDetails = (req) => {
    setLoading(true)
    var field = req.FieldName
    console.log(field)
    axiosFetch({
      method: "POST",
      url: "/data/update",
      requestConfig: req,
    })
      .then((res) => {
        if (res.status === 200) {
          if (res.data === "success") {
            if (field === "firstName") {
              if (lastName !== props.profile.lastName) {
                var req = {
                  "TypeId": 1,
                  "FieldName": "lastName",
                  "Value": lastName,
                  "ItemId": props.profile.id,
                  "TableName": "EmployeeDetails"
                }
                updateDetails(req)
              }
              else{
                dispatch(SnackbarActions(true, "success", "Updated successfully"))
              var close = document.getElementById("closebtn");
              close.click();
              setLoading(false)

              }
              
            }
            if (field === "lastName") {
              dispatch(SnackbarActions(true, "success", "Updated successfully"))
              var close = document.getElementById("closebtn");
              close.click();
              setLoading(false)

            }
            dispatch(profile_details(props.profile.id))
          }
        }
        if (res.status === 400) {
          dispatch(SnackbarActions(true, "error", "Something Went Wrong!"))
          setLoading(false)
        }
        if (res.status === 401) {
          // navigate("/");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  return (
    <div className="argus-profile-tab">
      {props.profile !== null ? (
        <Box>
          <Grid container spacing={2} sx={{ display: 'flex', alignItems: 'center' }}>
            <Grid item xs={4} >
              <Badge
                overlap="circular"
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                badgeContent={
                  (isUserLogged.useremail === props.profile.emailId || isUserLogged.usertype === "Admin" ||
                    isUserLogged.usertype === "SuperAdmin"
                    || isUserLogged.usertype === "HRManager"
                    || ((isUserLogged.usertype === "HR" && props.profile.userType !== "HRManager")
                      && (isUserLogged.usertype === "HR" && props.profile.userType !== "SuperAdmin") &&
                      (isUserLogged.usertype === "HR" && props.profile.userType !== "Admin"))
                  ) ?
                    <SmallAvatar>
                      <IconButton size="small" onClick={() => handleImagePopup()}>
                        <CameraAltIcon className="theme-icon" fontSize="inherit" />
                      </IconButton>
                    </SmallAvatar>
                    : false
                }

              >
                <Avatar
                  className="stensil avtar-photo"
                  sx={{
                    width: 100,
                    height: 100,
                    // padding: 2,
                    marginLeft: 2,
                  }}
                  alt=""
                  src={props.profile.profilePhotoName ? `/api/uploads/image/show/${props.profile.profilePhotoName}` : ''}
                  onClick={showProfileImage}
                />
              </Badge>
            </Grid>
            <Grid item xs={7} className="user-content">
              <Grid item>
                <h3 className="stensil user-name">
                  {props.profile.firstName + " " + props.profile.lastName}
                </h3>
              </Grid>
              {/* <Grid item>
                <h5 className="stensil user-designation">
                  {props.profile.jobTitle}
                </h5>
              </Grid> */}
            </Grid>
            {(isUserLogged.useremail === props.profile.emailId || isUserLogged.usertype === "Admin" ||
              isUserLogged.usertype === "SuperAdmin"
              || isUserLogged.usertype === "HRManager"
              || ((isUserLogged.usertype === "HR" && props.profile.userType !== "HRManager")
                && (isUserLogged.usertype === "HR" && props.profile.userType !== "SuperAdmin") &&
                (isUserLogged.usertype === "HR" && props.profile.userType !== "Admin"))
            ) ?
              <Grid item xs={1}>
                <PopupState variant="popper" popupId="demo-popup-popper">
                  {(popupState) => (
                    <div>
                      <IconButton aria-label="edit" size="small" {...bindToggle(popupState)}
                      >
                        <ModeEditIcon className="theme-icon" fontSize="inherit" />
                      </IconButton>
                      <Popover {...bindPopover(popupState)} transition classes={{ paper: "MuiPopover-paper" }}>
                        <Paper style={{ position: "fixed" }}>
                          <Grid container>
                            <Grid item xs={5} sx={{ padding: 1 }}>
                              <TextField id="filled-basic" label="First Name" variant="filled"
                                value={firstName}
                                onChange={(e) => setFirstName(e.target.value)} />
                            </Grid>
                            <Grid item xs={5} sx={{ padding: 1 }}>
                              <TextField id="filled-basic" label="Last Name" variant="filled"
                                value={lastName}
                                onChange={(e) => setLastName(e.target.value)} />
                            </Grid>
                            
                            <><Grid item xs={1} sx={{ paddingTop: 1 }}>
                              <IconButton disabled={loading} color="success" onClick={() => handleNameUpdate()}>
                                <CheckCircleIcon />
                              </IconButton>
                            </Grid>
                            <Grid item xs={1} sx={{ paddingTop: 1 }}>
                              <IconButton id="closebtn" sx={{ color: "red" }} {...bindToggle(popupState)}>
                                <CancelIcon />
                              </IconButton>
                            </Grid></>
                          </Grid>
                          {loading?
                            <LinearProgress color="success" />:""}
                        </Paper>
                      </Popover>
                    </div>
                  )}
                </PopupState>
              </Grid> : ""}
          </Grid>
        </Box>
      ) : (
        ""
      )}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
        onClick={handleClose}
      >
        <img
          src= {`/api/uploads/image/show/${props.profile.originalPhotoName}`}
          alt={props.profile.firstName + " " + props.profile.lastName}
          width="500"
          height="auto"
        />
      </Backdrop>
      <ProfileImage Id={props.Id} openModal={modalOpen} editImage={handleImagePopup} profileImage={props.profile.profilePhotoName} />
    </div>
  );
}
export default ProfileBoard;
